var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company__result--row mb-60"},_vm._l((_vm.filteredCompanies),function(company,index){return _c('HomeCompanyResultCard',{key:index,attrs:{"company":company}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }